const CONSUMER_CART_FRAGMENT = `
id 
additionalItems {
  giftWrapping {
    message
    price {
      base
    }
  }
}
customField {
  name
  value
}
customerDetails {
  contactNumber
  email
  firstName
  lastName
}
deliveryAddress {
  city
  country
  flatNumber
  coordinates {
    lat
    lng
  }
  lineOne
  lineTwo
  zip
  confidence
}
dropoffNotes
fulfillment {
  type
  orderType
  tableNumber
  window {
    from
    to
  }
}
loyaltyCards {
    description
    id
    name
    status
    availableRewards {
      id
      isApplicable
      details {
          description
          name
      }
      status
    }
}
saveAddress
marketingOptIn
minimumOrderValue
orderItems {
  id
  image {
    original
    standard
    thumb
  }
  modifierGroups {
    name
    modifiers {
      name
      price {
        base
        discounted
        reduction
      }
      quantity
    }
  }
  name
  options {
    name
    values
  }
  product {
    id
    name
  }
  quantity
  restrictions {
    alcoholic
  }
  total {
    base
    discounted
    reduction
  }
  variantId
  variantPrice {
    base
    discounted
    reduction
  }
}
orderNotes
potentialLoyaltyGains {
    points {
      total
    }
    stamps {
      total
    }
}
recipientDetails {
  contactNumber
  firstName
  lastName
}
store {
  id
  address {
    city
    country
    lineOne
    lineTwo
    zip
  }
  name
  slug
}
tipValues {
  amount
  percentage
}
summary {
  delivery {
    base
    discounted
    reduction
  }
  deliveryChargeInfo {
    reductionReason
    pricingBand {
      id
      lowerThreshold
      percentageDiscount
      upperThreshold
    }
  }
  deliveryPricingBands {
    id
    lowerThreshold
    percentageDiscount
    upperThreshold
  }
  discount {
    affectedProducts {
      id
      modifierGroups {
        id
        maximum
        minimum
        modifiers {
          id
          price {
            base
            discounted
            reduction
          }
        }
      }
      pricing {
        lowestVariant {
          base
          discounted
          reduction
        }
        maximum { 
          base
          discounted
          reduction
        }
        minimum {
          base
          discounted
          reduction
        }  
      }
      promotion {
        amount
        discountType
      }
      variants {
        id
        pricing {
          absolute {
            base
            discounted
            reduction
          }
          relative {
            base
            discounted
            reduction
          }
        }
      }
    }
    amount
    code
    description
  }
  reward {
    id
    amount
    description
    name
  }
  storeFee {
    label
    price { 
      base
      discounted
      reduction
    }
  }
  subtotal {
    base
    discounted
    reduction
  }
  tip
  total {
    base
    discounted
    reduction
  }
}`

const CONSUMER_CART_ERRORS_FRAGMENT = `
__typename
message
... on GenericCartError {
  message
}
... on InvalidModifiersError {
    message
    breakdown {
        productVariantId
        quantity
    }
}
... on ProductsOutOfStockError {
  message
  variants {
    id
    name
  }
}
... on ProductsUnavailableError {
      message
      variants {
        id
        name
      }
}
... on PriceChangedError {
    message
    priceComparison {
        newPriceWithVat
        oldPriceWithVat
        orderItemId
    }
}
... on ProductLimitReachedError {
    message
    variants {
        id
        limit
        name
    }
}
`

const CONSUMER_CART_WARNINGS_FRAGMENT = `
__typename
message
... on GenericCartWarning {
  message
}
... on InvalidTimeslotWarning {
message
isStoreOpen
nextAvailableTimeslot {
  datetime
  range
  value
}
}
... on InvalidTimeslotDynamicPreparationTimeWarning {
    message
    isStoreOpen
    restriction {
        maxPossibleBasketValue
        type
    }
}
... on InvalidTimeslotOriginalFulfillmentAvailableWarning {
    message
    fulfillmentDate
    fulfillmentTime
}
... on MinimumValueWarning {
    message
    minimumValue
    amountLeftToMinimumOrderValue
}
... on TargetCategoriesDiscountWarning {
    message
    categories {
        id
        name
    }
}
... on TargetProductsDiscountWarning {
    message
    products {
        id
        name
    }
}
... on TargetVariantsDiscountWarning {
    message
    variants {
        id
        name
    }
}
... on FulfillmentTypeInvalidDiscountWarning {
    message
    fulfillmentTypes
}
`

export {
  CONSUMER_CART_FRAGMENT,
  CONSUMER_CART_ERRORS_FRAGMENT,
  CONSUMER_CART_WARNINGS_FRAGMENT
}
